import type React from 'react';

import {
  OrdReferenceInput,
  LabelsInput,
  OrdSimpleForm,
  OrdFormList,
  OrdIconStandard,
} from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { required, TextInput } from 'react-admin';

import { OrdDescriptionInput } from 'src/components/formInputs';

const MobilityEditForm = ({ isPersonal = false }: { isPersonal?: boolean }): React.ReactElement => {
  return (
    <OrdSimpleForm replaceRelationships>
      <OrdFormList icon={<OrdIconStandard name='settings' />}>
        <TextInput source='name' validate={required()} fullWidth />
        <OrdDescriptionInput source='description' fullWidth />
        {!isPersonal ? (
          <OrdReferenceInput
            resource={Resources.users}
            validate={required()}
            source={'owner'}
            helperText='resources.mobility_configurations.helperTexts.owner'
          />
        ) : (
          <></>
        )}
      </OrdFormList>
      {!isPersonal && (
        <OrdFormList icon={<OrdIconStandard name='labels' />}>
          <LabelsInput />
        </OrdFormList>
      )}
    </OrdSimpleForm>
  );
};

export default MobilityEditForm;
